import { Box } from "@mui/material";
import { InHouseTooltip } from "../../../../components/InHouseTooltip/InHouseTooltip";
import type { DepartmentType } from "../../../../utils/models";
import { DEPARTMENT_TYPE_TO_COLOR } from "../../../../utils/utilFunctions";

export const SynergyFacilityOptionStartAdornment = ({ facilityType }: { facilityType?: DepartmentType }) => {
	return (
		<InHouseTooltip title={facilityType}>
			<Box
				sx={{
					width: 12,
					height: 12,
					borderRadius: "50%",
					backgroundColor: facilityType ? DEPARTMENT_TYPE_TO_COLOR[facilityType] : undefined,
				}}
			/>
		</InHouseTooltip>
	);
};
